import { IResponseDocInfo } from '../core/interfaces/online-api-service.interface';
import { DocInfoBaseManager } from '../../../core/managers/doc-info-manager.ts';
import { OnlineEditServices } from '../core/online-edit-services.core';
import { ILogger } from '../../../core/interfaces/logger.interface';
import { EditEvents, IEditEvents } from '../../../core/interfaces/event.interface';
import { IClientVarsService } from '../../../core/interfaces/client-vars-service.interface';

export class OnlineDocInfoManager extends DocInfoBaseManager {
    public constructor(
        protected logger: ILogger,
        protected editEvent: IEditEvents,
        protected clientVarsService: IClientVarsService,
    ) {
        super(logger, editEvent, clientVarsService);
        this.visible = this.clientVarsService.getClientVars().docStatus !== 12;
    }

    public async setDocVisible() {
        if (this.visible) return;
        const { transDocVisible } = await OnlineEditServices.OnlineApiService.promise();
        try {
            const res = await transDocVisible(this.domainId ?? '', this.padId ?? '');
            if (!res?.data) {
                throw new Error('set doc visible failed');
            }
            if (res.data.retcode === 0) {
                this.visible = true;
                window.SLR?.dispatch('DOC_HUMTRANS_DONE');
            }
        } catch (error) {
            this.logger.error(`[app] set doc visible failed, error: ${error.message}`);
            this.editEvent.emit(EditEvents.SetVisibleFailed);
        }
    }

    protected async getDocInfo(): Promise<IResponseDocInfo> {
        const onlineApiService = await OnlineEditServices.OnlineApiService.promise();
        const { domainId = '', padId = '' } = this.clientVars;
        try {
            const res = await onlineApiService
                .getDocInfo({ domainId, localPadId: padId, getCollected: 1, getIsAddedMy: 1 });
            return res.data;
        } catch (error) {
            this.logger.error('fetch doc info failed', error);
            this.editEvent.emit(EditEvents.LoadDocInfoError, error?.toString());
        }
        return {};
    }
}
